import { combineReducers } from '@reduxjs/toolkit';
import { reducer as credentialsReducer } from './model/credentials';
import { reducer as meReducer } from './model/me';
import { reducer as subordinatesReducer } from './model/subordinates';
import { reducer as divisionsReducer } from './model/divisions';
import { reducer as divisionEmployeesReducer } from './model/devisionEmployees';
export * as viewerModel from './model';

const viewerReducer = combineReducers({
  credentials: credentialsReducer,
  me: meReducer,
  subordinates: subordinatesReducer,
  divisions: divisionsReducer,
  divisionEmployees: divisionEmployeesReducer,
});
export default viewerReducer;
